import * as React from "react";

import { HDate } from "@hebcal/core";
import { useEffect, useState } from "react";
import { DateTimeInput, Labeled, useRecordContext, TextInput } from "react-admin";
import { useWatch, useFormContext } from 'react-hook-form';
import { Funeral } from "../types";
import { Typography, Stack, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from "moment";



export const FuneralDateOfDeathFields = () => {
  const record = useRecordContext<Funeral>();

  const dateOfDeath = useWatch<Funeral>({ name: `date_time_of_death` });
  const afterSunet = useWatch<Funeral>({ name: `death_after_sunset` });
  const [hebrewDate, setHebrewDate] = useState('');

  // const [dateValue, setDateValue] = React.useState<Date | null>(record ? record?.date_time_of_death : null);
  const [dateValue, setDateValue] = React.useState<Date | null>(
    record?.date_time_of_death ? new Date(record.date_time_of_death) : null
  );

  const { setValue, getValues } = useFormContext();

  const handleChange = (newValue: Date | null) => {
    const dateValue = moment.isMoment(newValue) ? newValue.toDate() : newValue;
    setValue("date_time_of_death", dateValue, { shouldDirty: true });
    setDateValue(dateValue);
  };

  useEffect(() => {

    if (dateOfDeath) {
      const tmpDate = moment.isMoment(dateOfDeath) ? dateOfDeath.toDate() : new Date(dateOfDeath);
      if (!isNaN(tmpDate.getTime())) {

        const currentHd: any = new HDate();
        const dateOfDeathAsDate = new Date(dateOfDeath);
        let hebrewDate = new HDate(dateOfDeathAsDate);

        if (afterSunet) {
          hebrewDate = hebrewDate.next();
        }

        setHebrewDate(hebrewDate.render().toString());
        setValue("yahrzeit_date", hebrewDate.render().toString(), { shouldDirty: true });

      }
    }
  }, [dateOfDeath, afterSunet]);

  return (
    <Stack>
      <TextInput hidden
        source="date_time_of_death"
        type="hidden"
        label={false}
        InputProps={{ disableUnderline: true }}
        helperText={false}
        sx={{ margin: 0 }}
      />
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DateTimePicker
          label="Date Time of Death"
          value={dateValue}
          onChange={handleChange}
          ampm={false}
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
     
    </Stack>
   
  );

}    